import { Action, createReducer, on } from "@ngrx/store";
import { initialState } from "./timer.state";
import { timerActions } from "./timer.actions";


export const timerReducer = (actions$: ReturnType<typeof timerActions>) => {
  return createReducer(
    initialState,
    on(
      actions$.incrementMinutes,
      (state) => {
        return {
          ...state,
          minutes: state.minutes + 1
        }
      },
    ),
    on(actions$.decrementMinutes,
      (state) => {
        return {
          ...state,
          minutes: state.minutes - 1 < 0? 0 : state.minutes - 1
        }
      },
    ),
    on(actions$.incrementSeconds,
      (state) => {
        return {
          ...state,
          seconds: state.seconds + 1
        }
      },
    ),
    on(actions$.decrementSeconds,
      (state) => {
        return {
          ...state,
          seconds: state.seconds - 1 < 0? 0 : state.seconds - 1
        }
      },
    ),
    on(actions$.tick,
      (state) => {
        let seconds = state.seconds
        let minutes = state.minutes
        if (state.seconds - 1 < 0) {
          seconds = 60
          minutes -= 1
        }
        seconds -= 1
        return {
          ...state,
          seconds: seconds,
          minutes: minutes
        }
      },
    )
  );
}
